import React from 'react';
import { useHistory } from 'react-router-dom';
import { getSessionStorage } from '@utils/windowUtil';

function ManageMHeader() {
  const history = useHistory();
  const goBack = () => {
    history.replace(`/project-detail/${getSessionStorage('currentId')}`, {
      preventRefresh: true,
    });
  };
  return (
    <>
      <span className="dd-back-btn" onClick={goBack}>
        <span className="appkiticon icon-left-chevron-fill a-font-12" /> Back
      </span>
      <div className="project-form-title capitalize-title">manage tiles</div>
    </>
  );
}

export default React.memo(ManageMHeader);
